import React from 'react';
import ReactDOM from 'react-dom';
import "./assets/css/bootstrap.min.css";
import "./assets/css/style.css";
import "./assets/css/custom.css";
import * as serviceWorker from './serviceWorker';

export const is_store = (process.env.REACT_APP_NAME === 'store');

const ReactApp = is_store ? 
require("./components/StoreApp/app").default : require("./App").default;

ReactDOM.render(<ReactApp />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
